import SPUserPickerConnected from './SPUserPickerConnected'

export default SPUserPickerConnected
